/* External Imports */
import { Box, Flex, Heading } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import config from '@config';
/* Configs */
import { ResearchShowsSt } from '@ieo/Common/CompLangConfig';
import ProgramSupportCard from './ProgramSupportCard';

/* Styles */

/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {string} region
 * @param {string} lang
 * @returns {ReactElement} component
 */
const IeoBenefitsV8WOB = ({ sectionContent, region, lang }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  return (
    <Box
      w="100%"
      mx="auto"
      px={{ base: '16px', sm: '0' }}
      pb={{ base: '40px', md: '80px', lg: '120px' }}
      position={'relative'}
    >
      <Box
        maxW={{
          base: '100%',
          sm: 'calc(100% - 66px)',
          xl: '1120px',
          '2xl': '1120px',
        }}
        w="100%"
        ml={{ base: '0', sm: '30px', md: '50px', xl: 'auto' }}
        mr={{ base: '0', sm: 'auto', xl: 'auto' }}
      >
        <Heading
          as="h3"
          color="#3B444B"
          fontFamily={ResearchShowsSt[lang]?.heading?.fontFamily}
          fontSize={{ base: '32px', md: '64px' }}
          fontStyle="normal"
          fontWeight={isIndian ? '600' : 'normal'}
          lineHeight={{ base: '38px', md: '64px' }}
          maxW="500px"
          textAlign={{ base: 'left', md: 'center' }}
          mx={{ base: '0', md: 'auto' }}
        >
          {sectionContent[0]?.titleText}
        </Heading>
        <Flex height="100%">
          <Flex
            justifyContent={{ base: 'center', xl: 'start' }}
            mt={{ base: '71px', md: '103px' }}
            flexWrap="wrap"
          >
            {searchByFieldId(sectionContent, 'research-shows-subtitle') && (
              <StructuredTextParser
                str={render(
                  searchByFieldId(sectionContent, 'research-shows-subtitle')
                    .body
                )}
                region={region}
                lang={lang}
                fontSize={{ base: '16px', lg: '18px' }}
                fontFamily="'FedraSansStd-book'"
                color="#6D6358"
                textAlign="center"
                px={{ base: '0', lg: '40px', xl: '166px' }}
                w="100%"
              />
            )}

            <Flex
              flexWrap="wrap"
              justifyContent="center"
              gridColumnGap={{ base: '38px', md: '40px' }}
              gridRowGap={{ base: '74px', md: '102px' }}
              css={{
                '-webkit-grid-row-gap': '25px !important',
                '-webkit-grid-column-gap': '38px',
              }}
            >
              {sectionContent[4]?.cards?.map((card, index) => {
                return (
                  <ProgramSupportCard
                    card={card}
                    lang={lang}
                    region={region}
                    key={nanoid()}
                    flexBasis={'auto'}
                  ></ProgramSupportCard>
                );
              })}
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default IeoBenefitsV8WOB;
